import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["badgeProps", "checkboxProps", "content", "countryIconId", "destructive", "icon", "iconLeading", "onClick", "onMenuClose", "shortcut"];
import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import { useTheme, styled } from '@mui/material/styles';
import { Checkbox } from '../../Checkbox';
import { MenuHeader } from './MenuHeader';
import Box from '@mui/system/Box';
import { Badge } from '../../Badge';
import { CountryIcon } from '../../CountryIcon';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var ITEM_CONTENT_GAP = 2;
export function DropDownMenuItems(_ref) {
  var _menuItemProps$0$;
  var handleMenuClose = _ref.handleMenuClose,
    hasPrimaryMenuHeader = _ref.hasPrimaryMenuHeader,
    menuItemProps = _ref.menuItemProps;
  var firstItemIsHeader = Array.isArray(menuItemProps[0]) && ((_menuItemProps$0$ = menuItemProps[0][0]) == null ? void 0 : _menuItemProps$0$.isHeader);
  return /*#__PURE__*/_jsx(Box, {
    className: "menu-inner-container",
    sx: {
      mb: '6px',
      mt: firstItemIsHeader || hasPrimaryMenuHeader ? 0 : '6px'
    },
    "data-element": "Box",
    "data-component": "DropDownMenuItems",
    "data-source-file": "DropDownMenuItem.tsx",
    children: menuItemProps.map(function (menuItem, index) {
      var last = index === menuItemProps.length - 1;
      return /*#__PURE__*/_jsx(Box, {
        //
        sx: {
          mb: last ? 1 : 0
        },
        children: Array.isArray(menuItem) ? /*#__PURE__*/_jsx(MenuItemGroup, {
          className: "menu-item-group",
          first: index === 0 ? 'true' : 'false',
          last: last ? 'true' : 'false',
          children: menuItem.map(function (item) {
            return item.isHeader ? /*#__PURE__*/_jsx(MenuHeader, {
              bottomMargin: true,
              headerContent: item.content
            }, item.id) : /*#__PURE__*/_jsx(DropdownMenuItem, _extends({}, item, {
              onMenuClose: handleMenuClose
            }), item.id);
          })
        }, index) : /*#__PURE__*/_jsx(DropdownMenuItem, _extends({}, menuItem, {
          onMenuClose: handleMenuClose
        }), menuItem.id)
      }, index);
    })
  });
}
var DropdownMenuItem = function DropdownMenuItem(props) {
  var theme = useTheme();
  var controlledBadgeProps = props.badgeProps,
    checkboxProps = props.checkboxProps,
    content = props.content,
    countryIconId = props.countryIconId,
    destructive = props.destructive,
    icon = props.icon,
    _props$iconLeading = props.iconLeading,
    iconLeading = _props$iconLeading === void 0 ? true : _props$iconLeading,
    onClick = props.onClick,
    onMenuClose = props.onMenuClose,
    shortcut = props.shortcut,
    others = _objectWithoutProperties(props, _excluded);
  var badgeProps = _extends({
    color: 'primary',
    size: 'sm',
    type: 'pillColor'
  }, controlledBadgeProps);
  var handleClick = function handleClick(e) {
    if (onClick) onClick(e);
    if (!checkboxProps) onMenuClose(e);
  };
  return /*#__PURE__*/_jsxs(StyledMenuItem, _extends({
    onClick: function onClick(e) {
      var _others$id;
      if (checkboxProps) checkboxProps.onChange && checkboxProps.onChange({
        target: {
          checked: !checkboxProps.checked,
          name: (_others$id = others.id) != null ? _others$id : ''
        }
      });
      handleClick(e);
    },
    tabIndex: 0
  }, others, {
    "data-element": "StyledMenuItem",
    "data-component": "DropdownMenuItem",
    "data-source-file": "DropDownMenuItem.tsx",
    children: [checkboxProps ? /*#__PURE__*/_jsx(Checkbox, _extends({}, checkboxProps, {
      sx: {
        gap: 0,
        margin: 0
      }
    })) : iconLeading && getIconContent(countryIconId, icon, theme, destructive), /*#__PURE__*/_jsx(ListItemText, {
      sx: {
        margin: "0 ".concat(shortcut || controlledBadgeProps ? theme.spacing(ITEM_CONTENT_GAP) : 0, " 0 ").concat(checkboxProps || icon ? theme.spacing(ITEM_CONTENT_GAP) : 0)
      },
      "data-element": "ListItemText",
      "data-source-file": "DropDownMenuItem.tsx",
      children: /*#__PURE__*/_jsx(Typography, {
        color: destructive ? theme.palette.error[700] : theme.palette.gray[700],
        sx: {
          whiteSpace: 'normal'
        },
        variant: "text-sm-medium",
        "data-element": "Typography",
        "data-source-file": "DropDownMenuItem.tsx",
        children: content
      })
    }), controlledBadgeProps && /*#__PURE__*/_jsx(Badge, _extends({}, badgeProps)), /*#__PURE__*/_jsx(Typography, {
      color: theme.palette.gray[500],
      sx: {
        ml: controlledBadgeProps ? 2 : 0
      },
      variant: "text-xs-regular",
      "data-element": "Typography",
      "data-source-file": "DropDownMenuItem.tsx",
      children: shortcut
    })]
  }));
};
var getIconContent = function getIconContent(countryIconId, icon, theme, destructive) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: countryIconId ? /*#__PURE__*/_jsx(CountryIcon, {
      id: countryIconId,
      size: 16,
      sx: {
        marginRight: '8px'
      }
    }) : icon && /*#__PURE__*/_jsx(ListItemIcon, {
      sx: {
        '& .zenith-icon, .MuiSvgIcon-root': {
          color: "".concat(destructive ? theme.palette.error[700] : theme.palette.gray[700], "!important"),
          height: '16px',
          width: '16px'
        },
        '&.MuiListItemIcon-root': {
          border: 'none',
          minWidth: '16px',
          width: '16px'
        }
      },
      children: icon
    })
  });
};
var StyledMenuItem = styled(MenuItem)(function (_ref2) {
  var theme = _ref2.theme;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&:hover", {
    backgroundColor: theme.palette.gray[50]
  }), "borderRadius", '6px'), "gap", 0), "margin", '2px 6px'), "minHeight", '44px!important'), "padding", '9px 10px'), "textAlign", 'left');
});
var MenuItemGroup = styled('div')(function (_ref4) {
  var first = _ref4.first,
    last = _ref4.last,
    theme = _ref4.theme;
  return {
    borderBottom: last === 'true' ? 'none' : "1px solid ".concat(theme.palette.gray[200]),
    marginBottom: '2px',
    paddingBottom: last === 'true' ? '0' : '4px',
    paddingTop: first === 'true' ? '0' : '2px'
  };
});